<template>
  <div ref="inputbox">
    <div
      v-show="showValue"
      class="sr__value"
    >
      {{ currentAllValueTitle }}
    </div>

    <div class="sr__input" :class="{'sr__input--invalid': !this.valid}">
      <b-form-checkbox-group
        class="sr__checkbox-group"
        v-model="selectedValue"
        @change="changeSelect"
        :disabled="field.disable || disable"
      >
        <span v-show="showValue">或：</span>

        <b-form-checkbox
          v-for="(option, oindex) in valueOptions"
          :key="oindex"
          :value="option.value"
          class="sr__value"
        >
          {{option.title}}
        </b-form-checkbox>
      </b-form-checkbox-group>
    </div>

    <b-form-invalid-feedback :state="valid">
      {{invalidMsg}}
    </b-form-invalid-feedback>
  </div>
</template>

<script>

export default {
  name: 'CheckboxItem',
  props: {
    field: Object,
    disable: Boolean
  },
  data () {
    return {
      valueOptions: [],
      fixedValue: [],
      showValue: false,
      selectedValue: [],
      toValidate: true,
      valid: true,
      invalidMsg: ''
    }
  },
  computed: {
    currentAllValueTitle () {
      return this.fixedValue.concat(this.currentSelectedValueTitle).join('、')
    },
    currentSelectedValueTitle () {
      return this.selectedValue.map((v) => {
        return this.valueOptions.find(e => e.value === v)?.title
      })
    }
  },
  methods: {
    changeSelect () {
      this.checkValueIsValid()
      this.$emit('update:value', this.selectedValue)
    },
    checkValueIsValid (uiNotify = true) {
      if (!this.toValidate) {
        this.valid = true
        this.invalidMsg = ''
        return true
      }

      if (this._isDestroyed) {
        this.valid = true
        this.invalidMsg = ''
        return true
      }

      if (this.selectedValue.length < 1) {
        if (!uiNotify) {
          return false
        }

        this.valid = false
        this.invalidMsg = '欄位必填'
      } else {
        this.valid = true
        this.invalidMsg = ''
      }

      return this.valid
    }
  },
  created () {
    this.toValidate = this.field.validates?.presence
    this.selectedValue = this.field.value.value
    this.fixedValue = this.field.value.options?.fixed_value
    this.showValue = this.field.value.options?.show_value
    this.valueOptions = this.field.value.value_options
  },
  mounted () {
    var top = this.$refs.inputbox.getBoundingClientRect().top

    if (this.toValidate) {
      this.$store.dispatch('pushValidateInfo', {
        id: this._uid,
        top: () => { return top },
        checkValueIsValid: this.checkValueIsValid
      })
    }
  }
}
</script>
